import React, {Component} from 'react';
import Modal from 'react-bootstrap-modal';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {memberDeleteWallPost, memberDeleteVideo} from 'reducers/member';

import 'sass/modals/modalConfirmDelete.scss';

import {t} from 'l10n';

class ModalConfirmPostDelete extends Component {
    onDelete = () => {
         const {memberDeleteWallPost, memberDeleteVideo, post, closeFn} = this.props;
         const action = post.type ? memberDeleteWallPost : memberDeleteVideo;
         action(post.id)
             .then(() => closeFn());
    };

    render() {
        const {show, closeFn, post} = this.props;
        return (
            <Modal className="modalConfirmDelete" show={show} onHide={closeFn}>
                <Modal.Body>
                    <div className="close" onClick={closeFn}/>

                    <p
                        className="text center"
                        dangerouslySetInnerHTML={{__html:
                                t("Do you really want to delete your material \"<strong class='nickname'>%1</strong>\"?",
                                    post.title || post.name)}}
                    />
                    <div className="form">
                        <div className="form-group">
                            <div className="buttons">
                                <button onClick={this.onDelete} className="delete">{t("Delete")}</button>
                                <button className="close" onClick={closeFn}>{t('Cancel')}</button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        )
    }
}

ModalConfirmPostDelete.propTypes = {
    show: PropTypes.bool.isRequired,
    post: PropTypes.object.isRequired,
    closeFn: PropTypes.func.isRequired,
    memberDeleteVideo: PropTypes.func.isRequired,
    memberDeleteWallPost: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
    memberDeleteWallPost,
    memberDeleteVideo
};

export default connect(null, mapDispatchToProps)(ModalConfirmPostDelete);


// WEBPACK FOOTER //
// ./src/components/modals/ModalConfirmPostDelete.js